<template>
  <article>
    <div class="wrap pt10">
      <header class="title-bar">
        <h2>请选择车身颜色</h2>
      </header>
      <div class="select-color-item">
        <ul>
          <li v-for="(item, index) in colors" :key="index" @click.stop="selColor(item.key)">
            <a href="javascript:void(0);" :class="getBgColor(item.key)">{{item.value}}</a>
          </li>
        </ul>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  data () {
    return {
      id: '',
      colors: []
    }
  },
  created () {
    this.id = this.$route.query.id
    this.$rest.saleManage.getEnums().then(res => {
      if (res.code === 0) {
        this.colors = res.data.car_color
      }
    })
  },
  methods: {
    selColor (key) {
      this.$router.push({ path: '/salemanage/car/inner', query: { id: this.id, outer: key } })
    },
    getBgColor (key) {
      let color = {}
      switch (key) {
        case '4':
          color = { 'black-bg': true }
          break
        case '1':
          color = { 'white-bg': true }
          break
        case '3':
          color = { 'gray-bg': true }
          break
        case '11':
          color = { 'red-bg': true }
          break
        case '8':
          color = { 'bule-bg': true }
          break
        case '7':
          color = { 'champagne-bg': true }
          break
        case '5':
          color = { 'brown-bg': true }
          break
        case '6':
          color = { 'yellow-bg': true }
          break
        case '10':
          color = { 'purple-bg': true }
          break
        case '2':
          color = { 'orange-bg': true }
          break
        case '9':
          color = { 'green-bg': true }
          break
      }
      return color
    }
  }
}
</script>
<style lang="less">
</style>
